import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { usersActions } from "../actions/users.actions";
import {
  Grid,
} from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import LoadingButton from "../components/LoadingButton";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonProgress: {
    color: theme.palette.primary,
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  errorMessage: {
    color: theme.palette.error.main,
    textAlign: "center",
    marginTop: theme.spacing(2),
  },
}));

export default function Login() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(usersActions.logout());
  }, [dispatch]);

  // Afficher les erreurs éventuelles retournées par le callback Azure
  const urlParams = new URLSearchParams(window.location.search);
  const error = urlParams.get("error");
  const errorDescription = urlParams.get("description");

  const getErrorMessage = (errorCode) => {
    // Si Azure a fourni une description, on la prioritise
    if (errorDescription) {
      return errorDescription;
    }
    switch (errorCode) {
      case "user_not_found":
        return "L'utilisateur avec cet email n'existe pas dans l'application.";
      case "no_email":
        return "Impossible de récupérer votre adresse email depuis Azure AD.";
      case "invalid_state":
        return "La requête d'authentification est invalide. Veuillez réessayer.";
      case "no_code":
        return "Aucun code d'autorisation reçu. Veuillez réessayer.";
      case "auth_failed":
        return "L'authentification a échoué. Veuillez réessayer.";
      default:
        return "Une erreur est survenue lors de la connexion.";
    }
  };

  const handleAzureLogin = () => {
    setLoading(true);
    fetch(process.env.REACT_APP_API_URL + "/azure/login")
      .then((response) => response.json())
      .then((data) => {
        if (data.redirectUrl) {
          window.location.href = data.redirectUrl;
        } else {
          setLoading(false);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  return (
    <div className={"login"}>
      <div className={"left-container"}></div>
      <div className={"right-container"}>
        <Grid
          container
          display="flex"
          alignItems="center"
          justify="center"
          id={"loginFormContainer"}
        >
          <Grid item>
            <Box mb={4}>
              <img
                src={require("../assets/images/login/onduline-logo.svg")}
                alt={"Logo Onduline"}
              />
            </Box>

            <Box mb={4}>
              <p className={"text-center"}>
                Bienvenue ! Merci de vous connecter
                <br />
                afin de pouvoir accéder à vos projets.
              </p>
            </Box>

            {error && (
              <Box mb={2}>
                <p className={classes.errorMessage}>
                  {getErrorMessage(error)}
                </p>
              </Box>
            )}

            <Box mt={4} className={"login-footer"}>
              <div className={classes.wrapper}>
                <LoadingButton
                  loading={loading}
                  variant="contained"
                  color="primary"
                  onClick={handleAzureLogin}
                >
                  Se connecter avec Microsoft
                </LoadingButton>
              </div>
            </Box>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
